import { Link, useLocation } from "react-router-dom";
import { Menu, Heart } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { GoogleTranslate } from "./GoogleTranslate";
import { AccessibilityToggle } from "./AccessibilityToggle";

export const Header = () => {
  const { t } = useLang();
  const { user } = useAuth();
  const { pathname } = useLocation();

  const navLink = (to, label, testid) => (
    <Link
      to={to}
      data-testid={testid}
      className={`text-sm font-semibold px-3 py-2 rounded-full transition-colors hover:bg-[#E8EFE9] hover:text-[#2E604A] ${
        pathname === to ? "text-[#2E604A] bg-[#E8EFE9]" : "text-stone-600"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-stone-200/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 min-w-0">
          <span className="w-9 h-9 rounded-xl bg-[#2E604A] text-white flex items-center justify-center shrink-0">
            <Heart className="w-5 h-5" fill="currentColor" strokeWidth={0} />
          </span>
          <span className="font-display font-extrabold text-[15px] sm:text-lg text-stone-900 truncate">
            {t("brand")}
          </span>
        </Link>

        <div className="flex items-center gap-1 sm:gap-2">
          <nav className="hidden md:flex items-center gap-1">
            {navLink("/", t("nav_directory"), "nav-directory")}
            {navLink("/map", t("nav_map"), "nav-map")}
            {navLink("/gallery", t("nav_gallery"), "nav-gallery")}
            {navLink("/events", t("nav_events"), "nav-events")}
            {navLink("/submit", t("nav_submit"), "nav-submit")}
            {user
              ? navLink("/admin", t("nav_admin"), "nav-admin")
              : navLink("/login", t("nav_admin"), "nav-admin")}
          </nav>

          <DropdownMenu>
            <DropdownMenuTrigger asChild className="md:hidden">
              <Button variant="ghost" size="icon" data-testid="mobile-menu" className="rounded-full">
                <Menu className="w-5 h-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="rounded-xl">
              <DropdownMenuItem asChild><Link to="/">{t("nav_directory")}</Link></DropdownMenuItem>
              <DropdownMenuItem asChild><Link to="/map">{t("nav_map")}</Link></DropdownMenuItem>
              <DropdownMenuItem asChild><Link to="/gallery">{t("nav_gallery")}</Link></DropdownMenuItem>
              <DropdownMenuItem asChild><Link to="/events">{t("nav_events")}</Link></DropdownMenuItem>
              <DropdownMenuItem asChild><Link to="/submit">{t("nav_submit")}</Link></DropdownMenuItem>
              <DropdownMenuItem asChild><Link to={user ? "/admin" : "/login"}>{t("nav_admin")}</Link></DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <GoogleTranslate />
          <AccessibilityToggle />
        </div>
      </div>
    </header>
  );
};
